import { useTranslation } from "react-i18next";

import type { FeasibilityReport } from "@/api/client";

// Vollständigkeits-Panel: zeigt Blocker (Audit nicht durchführbar) und Warnungen
// des Audit-Gates an — mit Deeplinks in den passenden Editor-Step, damit der
// User die fehlende Substanz in der Konstruktion ergänzt (statt Fake-Audit).
export default function FeasibilityPanel({
  report,
  onFix,
}: {
  report: FeasibilityReport;
  onFix: (step: number) => void;
}) {
  const { t } = useTranslation();
  if (report.feasible && report.warnings.length === 0) return null;

  return (
    <div className="space-y-4">
      {report.blockers.length > 0 && (
        <div className="p-6 bg-ca-card rounded-2xl border-2 border-verdict-red/60">
          <h3 className="text-lg font-black text-verdict-red uppercase tracking-tight mb-1">
            {t("feasibility.blockedTitle")}
          </h3>
          <p className="text-sm text-ca-surface-muted mb-4">
            {t("feasibility.blockedBody")}
          </p>
          <ul className="space-y-3">
            {report.blockers.map((f, i) => (
              <li key={i} className="flex flex-wrap items-center gap-3">
                <span className="flex-1 min-w-60 text-sm text-ca-surface-ink">{f.message}</span>
                <button
                  onClick={() => onFix(f.fix_step)}
                  className="px-3 py-1.5 rounded-md bg-ca-accent text-ca-brand text-xs font-bold hover:bg-brand-gold-dark transition"
                >
                  {t("feasibility.fixNow")}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      {report.warnings.length > 0 && (
        <div className="p-5 bg-ca-card rounded-2xl border border-ca-surface-border">
          <h4 className="text-xs font-black uppercase tracking-widest text-ca-surface-muted mb-3">
            {t("feasibility.warningsTitle")}
          </h4>
          <ul className="space-y-2">
            {report.warnings.map((f, i) => (
              <li key={i} className="flex flex-wrap items-center gap-3">
                <span className="flex-1 min-w-60 text-xs text-ca-surface-muted">{f.message}</span>
                <button
                  onClick={() => onFix(f.fix_step)}
                  className="text-xs font-semibold text-ca-surface-muted hover:text-ca-surface-accent transition"
                >
                  {t("feasibility.fix")}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
